import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import type { CommunityMember } from "@circle-react/types";

export const useIsCurrentUser = (member: CommunityMember) => {
  const { currentCommunityMember } = usePunditUserContext();
  return currentCommunityMember?.id === member.id;
};
